<template>
  <li class="dropdown notifications-menu">
    <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
      <country-flag :country="flag" size='small'/>
    </a>
    <ul class="dropdown-menu">
      <li class="header">
        <div class="row no-margin">
          <span class="col-xs-12 col-md-6 tab-link" @click="switchLang('es')">
            <country-flag country='es' size='small'/> Español
          </span>
          <span class="col-xs-12 col-md-6 tab-link" @click="switchLang('us')">
            <country-flag country='us' size='small'/> English
          </span>
          <span class="col-xs-12 col-md-6 tab-link"  @click="switchLang('de')">
            <country-flag country='de' size='small'/> Deutsche
          </span>
          <span class="col-xs-12 col-md-6 tab-link" @click="switchLang('br')">
            <country-flag country='br' size='small'/> Português
          </span>
        </div>
      </li>
    </ul>
  </li>
</template>

<script>
import CountryFlag from 'vue-country-flag'
import { mapState } from 'vuex'
import NotificationItem from './NotificationItem'
import {firebaseApp} from '../../helpers/firebaseApp'
import Vue2Filters from 'vue2-filters'

var db = firebaseApp.database()
var sd032019Ref = db.ref('sd032019')

export default {
  name: 'LanguagensMenu',
  components: {
    NotificationItem,
    CountryFlag
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      tab: 'new'
    }
  },
  firebase: {
    registros: {
      source: sd032019Ref,
      cancelCallback (err) {
        console.error(err)
      }
    }
  },
  computed: {
    ...mapState([
      'userInfo'
    ]),
    flag () {
      return this.$store.state.flag
    },
    newNotifications() {
      return this.userInfo.notifications.filter(n => !n.readAt)
    },
    oldNotifications() {
      return this.userInfo.notifications.filter(n => n.readAt)
    }
  },
  methods: {
    markAllAsRead() {
      event.stopPropagation()

      this.userInfo.notifications.filter(n => !n.readAt).forEach(function(notification) {
        notification.readAt = new Date().toUTCString
      })
    },
    switchLang(lang) {
      this.$store.commit('SET_LANG', lang)
    }
  }
}
</script>

<style scoped>
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu {
  width: 400px;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header {
  padding: 0;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header span.tab-link {
  padding: 4px;
  text-align: center;
  cursor: pointer;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header span.tab-link a {
  color: #444;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header span.tab-link.active {
  font-weight: bold;
  border-bottom: 2px solid #3c8dbc;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li.header span:hover.tab-link > a {
  color: #3c8dbc !important;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li > ul.menu {
  max-height: 300px;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li > ul.menu li > span {
  padding: 10px;
}
.navbar-custom-menu > .navbar-nav > li.notifications-menu > .dropdown-menu li:hover.footer > a {
  color: #3c8dbc !important;
}
</style>



// WEBPACK FOOTER //
// LanguagesMenu.vue?fc63c55e